import {
    PROFILES_FAILURE,
    PROFILES_REQUEST,
    PROFILES_SUCCESS,
    PROFILES_POST_SUCCESS,
    PROFILES_DELETE_SUCCESS,
    PROFILES_PATCH_SUCCESS,
    TRAINERS_POST_SUCCESS,
    TRAINERS_PATCH_SUCCESS, PROFILE_GET_SUCCESS,
} from 'actions';
import preserveArrayReference from 'utils/Array/preserveArrayReference';

const initialState = {
    data: [],
    isFetched: false,
    isFetching: false,
};

export const profileListReducer = (state = initialState, action) => {
    const { type, data, profile, trainer } = action;
    switch (type) {
        case PROFILES_DELETE_SUCCESS: {
            const newData = state.data.filter(d => d.id !== profile)
            return {
                ...state,
                data: [...newData]
            }
        }
        case TRAINERS_PATCH_SUCCESS:
        case TRAINERS_POST_SUCCESS: {
            const {profile} = trainer;
            return {
                ...state,
                data: state.data.map(d => d.id === profile.id ? {...d, trainer} : d)
            }
        }

        case PROFILE_GET_SUCCESS:
        case PROFILES_PATCH_SUCCESS: {
            // Upsert: PROFILE_GET_SUCCESS can populate a profile the bulk
            // list hasn't loaded yet, so a not-found id still needs to be
            // appended — but a normal edit of an already-loaded profile
            // must not reorder it to the array's end.
            const exists = state.data.some(d => d.id === profile.id);
            return {
                ...state,
                data: exists
                    ? state.data.map(d => d.id === profile.id ? profile : d)
                    : [...state.data, profile],
            }
        }

        case PROFILES_POST_SUCCESS: {
            return {
                ...state,
                data: [...state.data, profile]
            }
        }

        case PROFILES_SUCCESS: {return {
            ...state,
            isFetched: true,
            isFetching: false,
            data: preserveArrayReference(state.data, data),
        }}

        case PROFILES_REQUEST: {return {
            ...state,
            isFetching: true,
        }}

        case PROFILES_FAILURE: {return {
            ...state,
            isFetching: false,
        }}

        default: {return state}
    }
};
